import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Icon } from '../icons/Icon';
import { IconNames } from '../icons/Icons';
import styles from './Heading.module.scss';

export const Heading = ({ children, className, icon }: Props) => (
    <span className={classNames(styles.default, className)}>
        {icon && (
            <Icon type={icon} className={styles.icon} />
        )}

        {children}
    </span>
);

type Props = PropsWithChildren<{
    icon?: IconNames;
    className?: string;
}>;